export type AgencyFilterLabel = AgencyCode | WspAgencyLabel;

export enum AgencyCode {
  NOT_SELECTED = "",
  OTHER = "Other",
  WSP = "WSP",
  WSDOT = "WSDOT",
  KCM = "KCM",
  SFD = "SFD",
  SPD = "SPD",
  NWSA = "NWSA",
  Port = "Port",
  SDOT = "SDOT",
  ST = "ST",
  CityOfBellevue = "COB",
  EastsideFire = "EFR",
  CityOfGoldBar = "GLD",
  CityOfSultan = "SUL",
  MedinaPD = "MDPD",
  MaryPD = "MARYPD",
}

export enum AreaCode {
  I5 = "I5",
  WSP_D1 = "D1",
  WSP_D2 = "D2",
  WSP_D3 = "D3",
  WSP_D4 = "D4",
  WSP_D5 = "D5",
  WSP_D6 = "D6",
  WSP_D7 = "D7",
  WSP_D8 = "D8",
}

export enum RegionCode {
  NW = "NW",    // Northwest  
  SEA = "SEA",  // King County,      
  TAC = "TAC",  // Thurston, Peirce counties,
  SW = "SW",    // Southwest
  NC = "NC",    // North Central
  S = "S",      // South Central and Southeast
  E = "E",      // East
  PEN = "PEN",  // Olympic Peninsula
}

export const AgencyDelimeter = ": ";
export class WspAgencyLabel {
  // TODO: Consider whether we still need these as AgencyCodes or not.
  // May just need the AgencyRegionCode values. UI could use the combo of both enums, merhaps.
  // E.g., AgencyCode.WSP + ":" + AgencyRegionCode.NW
  static I5 = AgencyCode.WSP + AgencyDelimeter + AreaCode.I5;      // Subset of District 2
  static NW = AgencyCode.WSP + AgencyDelimeter + RegionCode.NW;    // District 7
  static SW = AgencyCode.WSP + AgencyDelimeter + RegionCode.SW;    // District 5
  static TAC = AgencyCode.WSP + AgencyDelimeter + RegionCode.TAC;  // District 1 (Pierce and Thurston county)
  static SEA = AgencyCode.WSP + AgencyDelimeter + RegionCode.SEA;  // District 2 (King County)  
  static S = AgencyCode.WSP + AgencyDelimeter + RegionCode.S;      // District 3
  static E = AgencyCode.WSP + AgencyDelimeter + RegionCode.E;      // District 4
  static NC = AgencyCode.WSP + AgencyDelimeter + RegionCode.NC;    // District 6
  static PEN = AgencyCode.WSP + AgencyDelimeter + RegionCode.PEN;  // District 8

  static WSP_North = "WSP-North"; // TODO: Re-work? This is a hard coded menu item value when inviting or editing a user. Needed still, or replaced by "WSP: NC" / "WSP: N"?
}

export const getWspAreaParamValue = (label: string): string | undefined => {
  switch (label) {
    case WspAgencyLabel.TAC:
      return AreaCode.WSP_D1;
    case WspAgencyLabel.SEA:
      return AreaCode.WSP_D2;
    case WspAgencyLabel.S:
      return AreaCode.WSP_D3;
    case WspAgencyLabel.E:
      return AreaCode.WSP_D4;
    case WspAgencyLabel.SW:
      return AreaCode.WSP_D5;
    case WspAgencyLabel.NC:
      return AreaCode.WSP_D6;
    case WspAgencyLabel.NW:
      return AreaCode.WSP_D7;
    case WspAgencyLabel.PEN:
      return AreaCode.WSP_D8;
    default:
      return undefined;
  }
};

export const getWspLabel = (area: AreaCode | string = ""): WspAgencyLabel | AgencyCode => {
  switch (area as AreaCode | RegionCode | AgencyCode) {
    case AreaCode.WSP_D1:
      return WspAgencyLabel.TAC;
    case AreaCode.WSP_D2:
    case AreaCode.I5: // For backwards compatibility
      return WspAgencyLabel.SEA;
    case AreaCode.WSP_D3:
      return WspAgencyLabel.S;
    case AreaCode.WSP_D4:
      return WspAgencyLabel.E;
    case AreaCode.WSP_D5:
    case RegionCode.SW: // For backwards compatibility
      return WspAgencyLabel.SW;
    case AreaCode.WSP_D6:
      return WspAgencyLabel.NC;
    case AreaCode.WSP_D7:
    case AgencyCode.OTHER: // For backwards compatibility
      return WspAgencyLabel.NW;
    case AreaCode.WSP_D8:
      return WspAgencyLabel.PEN;
    default:
      return AgencyCode.WSP;
  }
};
